
  //MUST HAVE "fill=black"
  const SVGCODE_LOCATION_OLD:String = '<svg id="Layer_1" enable-background="new 0 0 32 32" width="32" height="32" viewBox="0 0 510.993 510.993" xmlns="http://www.w3.org/2000/svg"> \
  <path fill="black" d="m255.497 0c-96.853 0-175.649 78.796-175.649 175.649v.667c0 34.718 9.311 68.882 26.926 98.799l134.535 228.488c2.687 4.563 7.58 7.371 12.874 7.389h.052c5.275 0 10.164-2.771 12.873-7.3l136.427-228.089c18.063-30.2 27.611-64.763 27.611-99.955-.001-96.852-78.797-175.648-175.649-175.648zm-1.263 255.496c-42.245 0-76.613-34.369-76.613-76.613s34.369-76.613 76.613-76.613 76.613 34.369 76.613 76.613-34.369 76.613-76.613 76.613z"/> \
  </svg>'

  const generateLocationSvgIconOld = (sixDigitsHexColor:string) => {
    const newColorSVG = SVGCODE_LOCATION.replace('fill="black"','fill="%23'+sixDigitsHexColor+'"');
    return 'data:image/svg+xml;utf-8, ' + newColorSVG;
  } 




  const SVGCODE_LOCATION:String = '<svg id="Layer_1" enable-background="new 0 0 32 32" width="SVG_WIDTH" height="SVG_HEIGHT" viewBox="0 0 510.993 510.993" xmlns="http://www.w3.org/2000/svg"> \
  <g id="g869"> \
  <path  \
      id="path19" \
      style="stroke-width:0;fill:%23DOWN_COLOR;fill-opacity:DOWN_OPACITY" \
      d="M 25.466797 5.7324219 L 8.2148438 19.822266 L 15.111328 31.537109 C 15.279597 31.822859 15.586442 31.998873 15.917969 32 L 15.921875 32 C 16.252212 32 16.556916 31.826589 16.726562 31.542969 L 25.271484 17.259766 C 26.402647 15.368546 27.000017 13.203834 27 11 C 26.999985 9.0545661 26.35663 7.3196657 25.466797 5.7324219 z " \
      transform="scale(15.968531)" /> \
  <path \
      id="path30" \
      style="stroke-width:0;stroke-opacity:1;fill:%23UP_COLOR;fill-opacity:UP_OPACITY" \
      d="M 16 0 C 9.9347584 0 5 4.9347584 5 11 L 5 11.041016 C 5 13.215167 5.5843792 15.355026 6.6875 17.228516 L 8.2148438 19.822266 L 25.466797 5.7324219 C 23.582444 2.3711976 20.119745 -8.0438816e-16 16 0 z " \
      transform="scale(15.968531)" /> \
  </g> \
  \
  <circle \
    style="fill:%23BULLET_COLOR;fill-opacity:BULLET_OPACITY;stroke-width:0" \
    id="path858" \
    cx="255.49649" \
    cy="172.12808" \
    r="71.486473" /> \
    <path \
   id="path860" \
   style="fill:%23CIRCLE_COLOR;fill-opacity:CIRCLE_OPACITY;stroke-width:0" \
   d="M 254.64312,61.732897 A 110.39448,110.39448 0 0 0 145.10091,172.11298 110.39448,110.39448 0 0 0 255.48098,282.52407 110.39448,110.39448 0 0 0 365.89209,172.11298 110.39448,110.39448 0 0 0 255.48098,61.732897 a 110.39448,110.39448 0 0 0 -0.83786,0 z m 0.83786,26.904563 a 83.489289,83.489289 0 0 1 83.50654,83.47552 83.489289,83.489289 0 0 1 -83.50654,83.50653 83.489289,83.489289 0 0 1 -83.4755,-83.50651 83.489289,83.489289 0 0 1 83.4755,-83.47554 z" /> \ \
   <g id="g869-5" \
   transform="matrix(0.97659549,0,0,0.97659549,421.08693,6.5502129)"> \
  <path \
     id="path19-4" \
     style="fill:none;fill-opacity:1;stroke:%23BORDER_COLOR;stroke-width:13.0967;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:BORDER_OPACITY" \
     d="m -169.35814,-0.01320192 c -96.853,0 -175.65384,78.80084392 -175.65384,175.65384192 v 0.65496 c 0,34.718 9.33167,68.8884 26.9469,98.80528 l 24.38944,41.41838 110.12671,187.06884 c 2.68701,4.56301 7.58688,7.37369 12.88088,7.39169 h 0.0624 c 5.275,0 10.14069,-2.76912 12.84968,-7.29811 L -21.306159,275.5999 C -3.2431479,245.3999 6.2959734,210.83263 6.295702,175.64064 6.2954625,144.57492 -3.9779718,116.87111 -18.187298,91.525155 -48.277647,37.85134 -103.57186,-0.01320192 -169.35814,-0.01320192 Z" /> \
  </g> \
 </svg>';

  //colors are RVB six-digit hexadecimal 
  const generateIconURL = (width:number,height:number,upColor:string,downColor:string,showBullet:boolean,bulletColor:string,showCircle:boolean,circleColor:string, downOpacity:string, upOpacity:string) => {

    if (isNaN(width) || width<=0 || width>500) width = 32;
    if (isNaN(height) || height<=0 || height>500) width = 32;
    if (!upColor || upColor.length!=6) upColor = '000000';
    if (!upOpacity) upOpacity = '1';
    if (!downColor || downColor.length!=6) downColor = '000000';
    if (!downOpacity) downOpacity = '1';
    if (!bulletColor || bulletColor.length!=6) bulletColor = '000000';
    if (!circleColor || circleColor.length!=6) circleColor = '000000';

    var customizedSVG = SVGCODE_LOCATION;
    customizedSVG = customizedSVG.replace('BORDER_COLOR',''+BORDER_COLOR);
    customizedSVG = customizedSVG.replace('BORDER_VISIBLE',''+BORDER_VISIBLE?'1':'0');
    customizedSVG = customizedSVG.replace('SVG_WIDTH',''+width);
    customizedSVG = customizedSVG.replace('SVG_HEIGHT',''+height);
    customizedSVG = customizedSVG.replace('UP_COLOR',upColor);
    customizedSVG = customizedSVG.replace('UP_OPACITY',upOpacity);
    customizedSVG = customizedSVG.replace('DOWN_COLOR',downColor);
    customizedSVG = customizedSVG.replace('DOWN_OPACITY',downOpacity);
    customizedSVG = customizedSVG.replace('BULLET_COLOR',bulletColor);
    customizedSVG = customizedSVG.replace('CIRCLE_COLOR',circleColor);
    customizedSVG = customizedSVG.replace('BULLET_OPACITY',showBullet?'1':'0');
    customizedSVG = customizedSVG.replace('CIRCLE_OPACITY',showCircle?'1':'0');

    return 'data:image/svg+xml;utf-8, ' + customizedSVG;
  } 
  export const generateCustomIcon = (width:number,height:number,upColor:string,downColor:string,showBullet:boolean,bulletColor:string,showCircle:boolean,circleColor:string,downOpacity:string,upOpacity:string) => {
    return {url: generateIconURL(width,height,upColor,downColor,showBullet,bulletColor,showCircle,circleColor,downOpacity,upOpacity)}
  }
  const BORDER_COLOR:string = '000000';
  const BORDER_VISIBLE:boolean = true;
  const BULLET_DEFAULT_COLOR:string = '000000';
  const CIRCLE_DEFAULT_COLOR:string = '888888'; //'333333';
  const DAY_COLOR:string = 'FFCA18'; //'decb2d';
  const NIGHT_COLOR:string = '888888';
  const SELECTED_ON_DUTY_COLOR:string = '6a93fd';//827ee8//'84b1e6';
  const SELECTED_BUT_FREE_COLOR:string = '67dddd';//6bafff
  const OUTSIDE_EXCLUSION_COLOR:string = 'ea735f';
  
  export const generateBasicIcon = (level:number,dayAndNight:boolean,selectedOnDuty:boolean,selectedButFree:boolean,outsideExclusion:boolean) => {
    const dayColor = selectedOnDuty?SELECTED_ON_DUTY_COLOR:selectedButFree?SELECTED_BUT_FREE_COLOR:outsideExclusion?OUTSIDE_EXCLUSION_COLOR:DAY_COLOR;
    return generateCustomIcon(32,32,dayColor,dayAndNight?NIGHT_COLOR:dayColor,level===3,BULLET_DEFAULT_COLOR,level===0,CIRCLE_DEFAULT_COLOR,'1','1');
  }


  